import React, { useState } from "react";

interface AvatarProps {
  firstName: string;
  lastName: string;
  imageUrl?: string;
  className: string;
  initials?: string;
  src?: string;
}

const Avatar: React.FC<AvatarProps> = ({ firstName, lastName, imageUrl, className }) => {
  const [imageError, setImageError] = useState(false);

  const initials = `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase(); // Extracts initials

  return (
    <div className={`bg-gray-300 dark:bg-gray-700 rounded-full flex items-center justify-center text-xl font-bold text-white dark:text-gray-100 overflow-hidden ${className}`}>
      {!imageError && imageUrl ? (
        <img
          src={imageUrl}
          alt={`${firstName} ${lastName}`}
          className="w-full h-full object-cover rounded-full"
          onError={() => setImageError(true)} // If image fails to load
        />
      ) : (
        <span className="text-sm">{initials}</span> // Show initials as fallback
      )}
    </div>
  );
};

export default Avatar;
